<chart #chart type="line" [data]="data" [options]="options"> </chart>
